import api from './client'
import type {
  BandSettings,
  BandCost,
  BandOrderItem,
  PreviousBandOrder,
  DuplicateCheckResult,
  StockBandOrder,
} from '../types'
import type { PaymentStartResponse } from '../types'

export async function getBandSettings(): Promise<BandSettings> {
  const { data } = await api.get('/bands/settings')
  return data
}

export async function getPreviousOrders(): Promise<PreviousBandOrder[]> {
  const { data } = await api.get('/bands/previous')
  return data.orders
}

export async function checkDuplicate(
  bandLetters: string,
  bandFrom: number,
  bandTo: number,
  existingItems: BandOrderItem[],
  personName: string,
): Promise<DuplicateCheckResult> {
  const { data } = await api.post('/bands/check-duplicate', {
    bandLetters,
    bandFrom,
    bandTo,
    existingItems,
    personName,
  })
  return data
}

export async function calculateCosts(items: BandOrderItem[]): Promise<{ items: BandCost[]; total: number }> {
  const { data } = await api.post('/bands/calculate', { items })
  return data
}

export async function startBandOrder(
  items: BandOrderItem[],
  shippingDetails: Record<string, string>,
): Promise<PaymentStartResponse> {
  const { data } = await api.post('/bands/order/start', { items, shippingDetails })
  return data
}

// pending: the payment may already be collected and is still being confirmed (HTTP 202).
export async function completeBandOrder(
  transactionId: string,
  fortisTransaction: { id: string; status_code: number },
): Promise<{ success?: boolean; pending?: boolean; message: string; transactionId?: string }> {
  const { data } = await api.post('/bands/order/complete', { transactionId, fortisTransaction })
  return data
}

export async function startStockBandOrder(
  order: StockBandOrder,
): Promise<PaymentStartResponse> {
  const { data } = await api.post('/bands/stock/start', {
    quantity: order.quantity,
    bandYear: order.bandYear,
    shippingDetails: order.shippingDetails,
  })
  return data
}

export async function completeStockBandOrder(
  transactionId: string,
  fortisTransaction: { id: string; status_code: number },
): Promise<{ success?: boolean; pending?: boolean; message: string; transactionId?: string }> {
  const { data } = await api.post('/bands/stock/complete', { transactionId, fortisTransaction })
  return data
}
